import React from 'react'
import Footer from '../../components/layout/Footer'

import { useSelector } from 'react-redux'
import { ensureObject } from '../../utils/helper'
import useDevices from '../../hooks/useDevices'

const FooterContainer = () => {
    const restaurantInfo = useSelector(state => state.RestaurantReducer);
    const { isDesktop } = useDevices();

    return isDesktop && <Footer restaurantInfo={ensureObject(restaurantInfo)}/>;
}

export default FooterContainer
